import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { registerEvmNetworkProviderBuilder } from '../../registerEvmNetworkProviderBuilder';
import { createWalletProviderForWaasEvm } from '../utils/createWalletProviderForWaasEvm';

export const WAAS_EVM_EXTENSION_KEY = 'waasEvm';

/**
 * Adds the Dynamic WaaS (Wallet as a Service) EVM extension to the Dynamic client.
 *
 * This extension enables embedded wallet functionality for EVM-compatible blockchains,
 * allowing users to have wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
  * @not-instrumented
 */
export const addWaasEvmExtension = (client = getDefaultClient()): void => {
  if (hasExtension({ extensionKey: WAAS_EVM_EXTENSION_KEY }, client)) {
    return;
  }

  registerExtension({ extensionKey: WAAS_EVM_EXTENSION_KEY }, client);
  registerEvmNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = createWalletProviderForWaasEvm({
    dynamicClient: client,
  });

  walletProviderRegistry.register({
    priority: WalletProviderPriority.WALLET_SDK,
    walletProvider,
  });
};
